import tfbank_logo_white_with_shield from 'img/tf-logos/tfbank21-logo-white.svg'
import tfbank_logo_white_without_shield from 'img/tf-logos/tfbank-text-logo-white.svg'
import tfbank_logo_black_with_bronze_shield from 'img/tf-logos/tfbank-full-color-logo.svg'
import tfbank_logo_black_with_bronze_shield_cropped from 'img/tf-logos/TF_logo_cropped.png'
import tfbank_logo_black_without_shield from 'img/tf-logos/tfbank-text-logo-black.svg'
import avarda_logo_white from 'img/avarda-logos/avarda-logo-white.svg'
import avarda_logo_black from 'img/avarda-logos/avarda-logo-black.svg'
import { ProductSettingTypes } from 'constants/enums/productTypes'

const avardaMarkets = ['uk']
const marketsWithoutShield = ['dk', 'se', 'fi', 'no', 'es', 'de'] // markets which shouldn't have the shield (unless when logged in with cards products for no and es)

// get the white company logo - either the 'avarda' or the 'TFBank' logo, with or without the shield
// called from lots of (mostly logged out) places
export function getWhiteCompanyLogo(
	market: string,
	productType?: ProductSettingTypes | undefined,
): string {
	return avardaBranding(market)
		? avarda_logo_white
		: shouldUseShield(market, productType)
			? tfbank_logo_white_with_shield
			: tfbank_logo_white_without_shield
}

// get the black company logo - either the 'avarda' or the 'TFBank' logo, with or without the (bronze) shield
// called from the header and idle timeout modal
export function getBlackCompanyLogo(
	market: string,
	cropped: boolean = false,
	productType?: ProductSettingTypes | undefined,
): string {
	return avardaBranding(market)
		? avarda_logo_black
		: shouldUseShield(market, productType)
			? cropped
				? tfbank_logo_black_with_bronze_shield_cropped
				: tfbank_logo_black_with_bronze_shield
			: tfbank_logo_black_without_shield
}

export function shouldUseShield(
	market: string,
	productType?: ProductSettingTypes | undefined,
): boolean {
	return (
		!avardaBranding(market) &&
		((productType && productType === ProductSettingTypes.Card) ||
			!marketsWithoutShield.includes(market))
	)
}

export function avardaBranding(market: string): boolean {
	return avardaMarkets.includes(market)
}